import { render } from "./ShimmerIcon.vue?vue&type=template&id=428791d0&scoped=true"
import script from "./ShimmerIcon.vue?vue&type=script&lang=js"
export * from "./ShimmerIcon.vue?vue&type=script&lang=js"

import "./ShimmerIcon.vue?vue&type=style&index=0&id=428791d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-428791d0"]])

export default __exports__